module.exports = __webpack_public_path__ + "img/concern_content_img.5a778503.png";